import React, { useEffect, useState } from "react";
import { Button, Input, Space, Typography, message } from "antd";
import { uuid6 } from "../../../helpers/helper";

const { Title, Text } = Typography;

const TaxConfigManager = ({types={},taxConfigs= [],onSave}) => {
  const [configs, setConfigs] = useState(
    JSON.parse(JSON.stringify(taxConfigs)) || []
);

  const [editMode, setEditMode] = useState(null); // null, 'add', or id
  const [activeConfig, setActiveConfig] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    components: [{ name: "", rate: "" }],
  });
  // useEffect((prevConfigs)=>{
  //   if (!_.isEqual(prevConfigs,configs)){
  //   if (configs.length){
  //   onSave(configs)
  //   setEditMode(false)
  //   }}
  // },[configs])
  const handleAdd = () => {
    setEditMode("add");
    setActiveConfig(null);
    setFormData({ name: "", components: [{ name: "", rate: "" }] });
  };

  const handleEdit = (config) => {
    setEditMode(config.id);
    setActiveConfig(config.id);
    setFormData({ name: config.name, components: [...config.components] });
  };

  const handleDelete = (id) => {
    setConfigs(configs.filter((c) => c.id !== id));
    onSave(configs.filter((c) => c.id !== id))
    if (activeConfig === id) {
      setEditMode(null);
      setActiveConfig(null);
    }
    message.success("Configuration deleted");
  };

  const handleSave = () => {
    if (!formData.name.trim()) {
      message.error("Please enter configuration name");
      return;
    }

    if(editMode === "add" && configs.filter(item=>item.name == formData.name).length>0){
      message.error("Configuration name already exists");
      return;

    }

    if (editMode === "add") {
      const newConfig = {
        id: uuid6(),
        name: formData.name,
        components: formData.components.filter((c) => c.name && c.rate !== ""),
      };
      setConfigs([...configs, newConfig]);
      onSave([...configs, newConfig])
    //   message.success("Configuration added");
    } else {
      setConfigs(
        configs.map((c) =>
          c.id === editMode
            ? {
                ...c,
                name: formData.name,
                components: formData.components.filter(
                  (c) => c.name && c.rate !== ""
                ),
              }
            : c
        )
      );
      onSave(configs.map((c) =>
          c.id === editMode
            ? {
                ...c,
                name: formData.name,
                components: formData.components.filter(
                  (c) => c.name && c.rate !== ""
                ),
              }
            : c
        ))

    //   message.success("Configuration updated");
    }

    setEditMode(null);
    setActiveConfig(null);
  };

  const handleCancel = () => {
    setEditMode(null);
    setActiveConfig(null);
  };

  const addComponent = () => {
    setFormData({
      ...formData,
      components: [...formData.components, { name: "", rate: "" }],
    });
  };

  const removeComponent = (index) => {
    setFormData({
      ...formData,
      components: formData.components.filter((_, i) => i !== index),
    });
  };

  const updateComponent = (index, field, value) => {
    const newComponents = [...formData.components];
    newComponents[index][field] = value;
    setFormData({ ...formData, components: newComponents });
  };

  const calculateTotal = () => {
    return formData.components
      .reduce((sum, c) => sum + (parseFloat(c.rate) || 0), 0)
      .toFixed(2);
  };

  const getTotalRate = (components) => {
    return components.reduce((sum, c) => sum + parseFloat(c.rate), 0);
  };

  return (
    <div style={{ height: "100vh", display: "flex" }}>
      {/* Left Panel */}
      <div
        style={{
          width: !editMode ? "100%" : 400,
          background: "white",
          borderRight: editMode ? "1px solid #e8e8e8" : "0px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ padding: 20, borderBottom: "1px solid #e8e8e8" }}>
          <Title level={4} style={{ margin: 0 }}>
            Tax Configurations
          </Title>
          <Button
            type="primary"
            onClick={handleAdd}
            style={{ marginTop: 12, width: "100%" }}
          >
            + Create New Configuration
          </Button>
        </div>
        <div
          style={
            !editMode
              ? {
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: 16,
                  overflowY: "auto",
                  padding: 16,
                }
              : { flex: 1, overflowY: "auto", padding: 8 }
          }
        >
          {configs.map((config) => (
            <div
              key={config.id}
              onClick={() => handleEdit(config)}
              style={{
                padding: 16,
                border: `1px solid ${
                  activeConfig === config.id ? "#1890ff" : "#e8e8e8"
                }`,
                borderRadius: 8,
                marginBottom: 8,
                cursor: "pointer",
                background: activeConfig === config.id ? "#e6f7ff" : "white",
                transition: "all 0.2s",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 8,
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 16 }}>
                  {config.name}
                </div>
                <div
                  style={{ fontWeight: 700, fontSize: 18, color: "#1890ff" }}
                >
                  {getTotalRate(config.components)}%
                </div>
              </div>
              <div style={{ fontSize: 13, color: "#666" }}>
                {config.components.map((c, i) => (
                  <span key={i}>
                    {c.name} {c.rate}%
                    {i < config.components.length - 1 ? " + " : ""}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Right Panel */}
      {editMode ? (
        <div
          style={{
            flex: 1,
            background: "white",
            display: "flex",

            justifyContent: "center",
            padding: 30,
          }}
        >
          <div style={{ width: "100%", maxWidth: 700 }}>
            <Title level={3} style={{ marginBottom: 8 }}>
              {editMode === "add"
                ? "Create Tax Configuration"
                : "Edit Tax Configuration"}
            </Title>
            <Text
              type="secondary"
              style={{ marginBottom: 24, display: "block" }}
            >
              Define your tax structure with multiple components
            </Text>

            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              <div>
                <Text strong style={{ display: "block", marginBottom: 8 }}>
                  Configuration Name
                </Text>
                <Input
                  size="large"
                  placeholder="e.g., GST 18%, Standard Rate"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                />
              </div>

              <div>
                <Text strong style={{ display: "block", marginBottom: 8 }}>
                  Tax Components
                </Text>
                {formData.components.map((component, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", gap: 12, marginBottom: 12 }}
                  >
                    <Input
                      placeholder="Component name (e.g., CGST)"
                      value={component.name}
                      onChange={(e) =>
                        updateComponent(index, "name", e.target.value)
                      }
                      style={{ flex: 1 }}
                    />
                    <div style={{ position: "relative", width: 120 }}>
                      <Input
                        type="number"
                        placeholder="0.00"
                        value={component.rate}
                        onChange={(e) =>
                          updateComponent(index, "rate", e.target.value)
                        }
                        style={{ textAlign: "right", paddingRight: 30 }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: 12,
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#999",
                          fontWeight: 600,
                          pointerEvents: "none",
                        }}
                      >
                        %
                      </span>
                    </div>
                    {formData.components.length > 1 && (
                      <Button danger onClick={() => removeComponent(index)}>
                        ×
                      </Button>
                    )}
                  </div>
                ))}
                <Button
                  type="dashed"
                  onClick={addComponent}
                  style={{ width: "100%", marginTop: 8 }}
                >
                  + Add Component
                </Button>
              </div>

              <div
                style={{
                  background:
                    "linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%)",
                  border: "2px solid #91d5ff",
                  borderRadius: 8,
                  padding: 20,
                  textAlign: "center",
                  margin: "20px 0",
                }}
              >
                <div
                  style={{ fontSize: 14, color: "#0050b3", marginBottom: 8 }}
                >
                  Total Tax Rate
                </div>
                <div
                  style={{ fontSize: 36, fontWeight: 700, color: "#1890ff" }}
                >
                  {calculateTotal()}%
                </div>
              </div>

              <Space style={{ width: "100%" }}>
                <Button
                  type="primary"
                  size="large"
                  onClick={handleSave}
                  style={{ flex: 1 }}
                >
                  Save Configuration
                </Button>
                <Button size="large" onClick={handleCancel}>
                  Cancel
                </Button>
                {editMode !== "add" && Object.keys(types).filter((type)=>types[type]['taxConfig'] == activeConfig).length == 0 && (
                  <Button
                    danger
                    size="large"
                    onClick={() => handleDelete(editMode)}
                  >
                    Delete
                  </Button>
                )}
              </Space>
            </Space>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default TaxConfigManager;
